module.exports = __webpack_public_path__ + "static/media/unauthorized.74af6319.png";